import { WorkspaceBranding, WorkspaceSettings, WorkspaceUsers } from 'components/ManageWorkspace'
import { AcceptInvitePage, HomePage, ManageMediaPage } from 'components/pages'
import { createBrowserRouter } from 'react-router'
import { IRoute } from 'types'
import { WorkspacePath } from 'utils'
import {
  DeveloperPage,
  DiagnosticsPage,
  EventsInfoPage,
  EventsPage,
  FacilitiesPage,
  FacilityInfoPage,
  IntegrationsPage,
  IntelligencePage,
  NewPassword,
  OnTheGoMemberPage,
  OnTheGoMembersPage,
  ProfilePage,
  RegistrationConsentInfoPage,
  RegistrationConsentsPage,
  ResetPassword,
  RootPage,
  SubscriptionPage,
  TemplateInfoPage,
  TemplatesPage,
  TextContentPage,
  ToolContentPage,
  TraitContentPage,
  WorkspaceAnalyticsPage,
  WorkspacePage,
  WorkspacePropertiesPage,
} from '../pages'

export enum RouteName {
  Analytics = 'analytics',
  Content = 'content',
  Developer = 'developer',
  Diagnostics = 'diagnostics',
  EventInfo = 'eventInfo',
  Events = 'events',
  Facilities = 'facilities',
  ManageWorkspace = 'manageWorkspace',
  ManageWorkspaceBranding = 'manageWorkspaceBranding',
  ManageWorkspaceUsers = 'manageWorkspaceUsers',
  Media = 'media',
  OnTheGo = 'onTheGo',
  OnTheGoMember = 'onTheGoMember',
  Profile = 'profile',
  Properties = 'properties',
  RegistrationConsents = 'consents',
  Subscription = 'subscription',
  Templates = 'templates',
  Text = 'text',
  Intelligence = 'intelligence',
  Integrations = 'integrations',
  Tool = 'tools',
  Trait = 'traits',
}

export enum RoutePath {
  Content = `${WorkspacePath}/${RouteName.Content}`,
  Developer = `${WorkspacePath}/${RouteName.Developer}`,
  Diagnostics = `/${RouteName.Diagnostics}`,
  EventInfo = `${WorkspacePath}/${RouteName.Events}/:id`,
  Events = `${WorkspacePath}/${RouteName.Events}`,
  Facilities = `${WorkspacePath}/${RouteName.Facilities}`,
  FacilityInfo = `${WorkspacePath}/${RouteName.Facilities}/:id`,
  GlobalProfile = `/${RouteName.Profile}`,
  Home = '/',
  Intelligence = `${WorkspacePath}/${RouteName.Intelligence}`,
  Integrations = `${WorkspacePath}/${RouteName.Integrations}`,
  Invite = `/invite${WorkspacePath}`,
  ManageMedia = `${WorkspacePath}/${RouteName.Media}`,
  ManageWorkspace = `${WorkspacePath}/${RouteName.ManageWorkspace}`,
  ManageWorkspaceBranding = `${WorkspacePath}/${RouteName.ManageWorkspaceBranding}`,
  ManageWorkspaceUsers = `${WorkspacePath}/${RouteName.ManageWorkspaceUsers}`,
  NewPassword = `/new-password/`,
  OnTheGoMember = `${WorkspacePath}/${RouteName.OnTheGo}/:id`,
  OnTheGo = `${WorkspacePath}/${RouteName.OnTheGo}`,
  Profile = `${WorkspacePath}/${RouteName.Profile}`,
  Properties = `${WorkspacePath}/${RouteName.Properties}`,
  RegistrationConsents = `${WorkspacePath}/${RouteName.RegistrationConsents}`,
  RegistrationConsentInfo = `${WorkspacePath}/${RouteName.RegistrationConsents}/:id`,
  ResetPassword = '/reset-password',
  Subscription = `${WorkspacePath}/${RouteName.Subscription}`,
  Templates = `${WorkspacePath}/${RouteName.Templates}`,
  TemplateInfo = `${WorkspacePath}/${RouteName.Templates}/:id`,
  Text = `${WorkspacePath}/${RouteName.Text}/`,
  TextInfo = `${WorkspacePath}/${RouteName.Text}/:id`,
  Tool = `${WorkspacePath}/${RouteName.Tool}/`,
  ToolInfo = `${WorkspacePath}/${RouteName.Tool}/:id`,
  Trait = `${WorkspacePath}/${RouteName.Trait}/`,
  TraitInfo = `${WorkspacePath}/${RouteName.Trait}/:id`,
  Workspace = `${WorkspacePath}`,
  WorkspaceAnalytics = `${WorkspacePath}/${RouteName.Analytics}`,
}

export const routes: IRoute[] = [
  {
    path: RoutePath.Invite,
    element: <AcceptInvitePage />,
    isPublic: true,
  },
  {
    path: RoutePath.Home,
    element: <HomePage scope={'emp'} />,
  },
  {
    path: RoutePath.GlobalProfile,
    element: <ProfilePage />,
  },
  {
    path: RoutePath.Diagnostics,
    element: <DiagnosticsPage />,
    isPublic: true,
  },
  {
    path: RoutePath.ResetPassword,
    element: <ResetPassword />,
  },
  {
    path: RoutePath.NewPassword,
    element: <NewPassword />,
    isPublic: true,
  },
  {
    path: RoutePath.Workspace,
    element: <RootPage />,
    children: [
      {
        path: RoutePath.Workspace,
        element: <WorkspacePage />,
      },
      {
        path: RoutePath.Profile,
        element: <ProfilePage />,
      },
      {
        path: RoutePath.Events,
        element: <EventsPage />,
      },
      {
        path: RoutePath.EventInfo,
        element: <EventsInfoPage />,
      },
      {
        path: RoutePath.Facilities,
        element: <FacilitiesPage />,
      },
      {
        path: RoutePath.FacilityInfo,
        element: <FacilityInfoPage />,
      },
      {
        path: RoutePath.Content,
        element: <TextContentPage />,
      },
      {
        path: RoutePath.Templates,
        element: <TemplatesPage />,
      },
      {
        path: RoutePath.TemplateInfo,
        element: <TemplateInfoPage />,
      },
      {
        path: RoutePath.Trait,
        element: <TraitContentPage />,
      },
      {
        path: RoutePath.TraitInfo,
        element: <TraitContentPage />,
      },
      {
        path: RoutePath.Text,
        element: <TextContentPage />,
      },
      {
        path: RoutePath.TextInfo,
        element: <TextContentPage />,
      },
      {
        path: RoutePath.Tool,
        element: <ToolContentPage />,
      },
      {
        path: RoutePath.ToolInfo,
        element: <ToolContentPage />,
      },
      {
        path: RoutePath.ManageMedia,
        element: <ManageMediaPage />,
      },
      {
        path: RoutePath.OnTheGoMember,
        element: <OnTheGoMemberPage />,
      },
      {
        path: RoutePath.OnTheGo,
        element: <OnTheGoMembersPage />,
      },
      {
        path: RoutePath.RegistrationConsents,
        element: <RegistrationConsentsPage />,
      },
      {
        path: RoutePath.RegistrationConsentInfo,
        element: <RegistrationConsentInfoPage />,
      },
      {
        path: RoutePath.WorkspaceAnalytics,
        element: <WorkspaceAnalyticsPage />,
      },
      {
        path: RoutePath.Properties,
        element: <WorkspacePropertiesPage />,
      },
      {
        path: RoutePath.ManageWorkspace,
        element: <WorkspaceSettings />,
      },
      {
        path: RoutePath.ManageWorkspaceBranding,
        element: <WorkspaceBranding />,
      },
      {
        path: RoutePath.ManageWorkspaceUsers,
        element: <WorkspaceUsers />,
      },
      {
        path: RoutePath.Integrations,
        element: <IntegrationsPage />,
      },
      {
        path: RoutePath.Intelligence,
        element: <IntelligencePage />,
      },
      {
        path: RoutePath.Subscription,
        element: <SubscriptionPage />,
      },
      {
        path: RoutePath.Developer,
        element: <DeveloperPage />,
      },
      {
        path: '*',
        element: <HomePage scope={'emp'} />,
      },
    ],
  },
]

export default createBrowserRouter(routes)
